import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatINR } from "../lib/api";
import { ArrowLeft, UserCog, Activity } from "lucide-react";

function Stat({ label, value, testId }) {
  return (
    <div className="bg-white border border-[#E5E3DB] p-4">
      <div className="text-[11px] uppercase tracking-wide text-[#68665E]">{label}</div>
      <div className="text-lg font-semibold text-[#1A1A18] mt-1" data-testid={testId}>{value}</div>
    </div>
  );
}

const ACTION_COLORS = { create: "text-[#2F6F4E]", update: "text-[#8A6D1B]", delete: "text-[#8A2526]", status: "text-[#C84B31]" };

export default function StaffWork() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/users/${id}/work`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [id]);

  if (!data) return <div className="text-sm text-[#68665E]">Loading…</div>;
  if (data.error) return <div className="text-sm text-[#8A2526]">Could not load staff (admin only).</div>;
  const s = data.summary;
  const u = data.user;

  return (
    <div data-testid="staff-work-page">
      <button className="btn-ghost text-sm mb-4" onClick={() => navigate(-1)}><ArrowLeft className="w-4 h-4" /> Back</button>
      <div className="flex items-center gap-3 mb-6">
        <UserCog className="w-8 h-8 text-[#C84B31]" />
        <div>
          <div className="text-xs uppercase tracking-widest text-[#68665E] font-semibold">Staff Activity · {u.role}</div>
          <h1 className="font-headings text-4xl font-bold text-[#1A1A18]" data-testid="staff-work-name">{u.name}</h1>
          <div className="text-sm text-[#68665E]">{u.email}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mb-8">
        <Stat label="LRs" value={s.lrs_created} testId="sw-lrs" />
        <Stat label="Invoices" value={s.invoices_created} testId="sw-invoices" />
        <Stat label="Expenses" value={s.expenses_created} testId="sw-expenses" />
        <Stat label="Freight" value={formatINR(s.freight_handled)} />
        <Stat label="Invoiced" value={formatINR(s.invoiced_value)} />
        <Stat label="Expense ₹" value={formatINR(s.expense_value)} />
      </div>

      <h2 className="font-headings text-lg font-bold mb-3 flex items-center gap-2"><Activity className="w-4 h-4" /> Activity Timeline</h2>
      <div className="bg-white border border-[#E5E3DB] divide-y divide-[#E5E3DB]" data-testid="staff-activity-list">
        {data.activity.length === 0 ? <div className="px-4 py-3 text-sm text-[#A09E96]">No recorded activity yet.</div> : data.activity.map((a) => (
          <div key={a.id} className="flex items-center gap-3 px-4 py-2 text-sm" data-testid={`sw-activity-${a.id}`}>
            <span className={`uppercase text-[11px] font-bold w-16 ${ACTION_COLORS[a.action] || ""}`}>{a.action}</span>
            <span className="w-20 text-[#68665E]">{a.entity}</span>
            <button className="text-[#C84B31] hover:underline flex-1 text-left truncate" onClick={() => { if (a.entity === "lr") navigate(`/lr/${a.entity_id}`); }}>
              {a.entity_label || a.entity_id}
            </button>
            <span className="text-[11px] text-[#68665E]">{String(a.timestamp).replace("T", " ").slice(0, 16)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
